// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"9da28a1a","453":"d8ef353f","455":"9a3580d3","656":"a54e914b"}[chunkId] + ".chunk.js";
};